import { NgModule } from '@angular/core';
import { ListMissionPlaceComponent } from './list-mission-place/list-mission-place.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailMissionPlaceComponent } from './detail-mission-place/detail-mission-place.component';
import { MissionPlaceFormComponent } from './mission-place-form/mission-place-form.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { MissionPlaceModalAjoutFormComponent } from './modal/mission-place-modal-ajout-form/mission-place-modal-ajout-form.component';

@NgModule({
	declarations: [
		ListMissionPlaceComponent,
		DetailMissionPlaceComponent,
		MissionPlaceFormComponent,
		MissionPlaceModalAjoutFormComponent
	],
	imports: [SharedModule, GestionDonneesModule]
})
export class MissionPlaceModule {}
